import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { BuyerInvitationService } from '../../services/buyer-invitation.service';
import { Subscription } from '../../../../../../../node_modules/rxjs';
import { MobileProviderViewModel } from '../../../profile/profile.component';
import { BuyerInformationModel, MailInvitationEnum } from '../../Models/BuyerInformationModel';
import { SignalRService } from '../../../../../services/signalr.service';
import { DxDataGridComponent } from '../../../../../../../node_modules/devextreme-angular';
import { Router } from '../../../../../../../node_modules/@angular/router';
import { CommonService } from '../../../../../shared/services/common.service';
import { CustomNotification } from '../../../../../CustomNotification';
import { Utilities } from '../../../../../Utilities';
import { SubscriptionService } from '../../../../../shared/services/subscription.service';


@Component({
  selector: 'app-buyer-invitation',
  templateUrl: './buyer-invitation.component.html',
  styleUrls: ['./buyer-invitation.component.css']
})
export class BuyerInvitationComponent implements OnInit, OnDestroy {
  public communities: MobileProviderViewModel[] = [];
  public buyerData: BuyerInformationModel[] = [];
  private subscriptions: Subscription[] = [];
  public yetTobeSent: MailInvitationEnum = MailInvitationEnum.YetToBeSent;
  public sent: MailInvitationEnum = MailInvitationEnum.Sent;
  public failed: MailInvitationEnum = MailInvitationEnum.Failed;
  public CommunityID: Number = 0;
  
  @ViewChild("buyerGrid") buyerGrid: DxDataGridComponent;

  constructor(private buyerInvitationService: BuyerInvitationService
    , private signalRService: SignalRService,
    private commonService: CommonService,
    private customNotification: CustomNotification,
    private router: Router,public subscriptionService: SubscriptionService) { }

  ngOnInit() {
    this.subscriptions.push(this.commonService.AuthUser.subscribe(x => {
      if (x && x.BuyerID !== 0) {
        this.router.navigate(['/dashboard/']);
      }
    }));
    this.subscriptions.push(this.buyerInvitationService.getCommunityListForBuyerMailNotification().subscribe(x => {
      this.communities = x ? x : [];
    }));
    this.subscriptions.push(this.signalRService.updateMailNotification$.subscribe(response => {
      if (response) {
        if (this.buyerData.some(x => x.BuyerID === response.BuyerID)) {
          let currentBuyer = this.buyerData.find(x => x.BuyerID === response.BuyerID);
          currentBuyer.MailStatus = <MailInvitationEnum>response.MailStatus;
          currentBuyer.IsMailInvitationSent = true;
          this.buyerGrid.instance.refresh();
        }
      }
    }));
  }

  public onCommunityValueChanged(event: any) {
    this.subscriptions.push(this.buyerInvitationService.getBuyerInformationFromCommunityID(+event.value).subscribe(x => {
      this.buyerData = x ? x : [];
      this.buyerData.forEach(x => x.MailStatus = x.IsMailInvitationSent ? this.sent : this.yetTobeSent);
      this.CommunityID=event.value;
    }));
  }

  ngOnDestroy() {
    this.subscriptions.forEach(x => x.unsubscribe());
  }

  public sendEmail() {
    let selectedRowKeys: BuyerInformationModel[] = this.buyerGrid.instance.getSelectedRowKeys();
    if (selectedRowKeys.length === 0) {
      this.customNotification.notify('Please select a buyer to send mail invitation.', '', Utilities.warning);
    }
    
    selectedRowKeys.map(x => {
      console.log(x.CommunityLotID);
    
      this.subscriptions.push(this.buyerInvitationService.sendMailToBuyer(x.BuyerID,x.CommunityLotID).subscribe(x => {
        this.customNotification.notify(x.message, "", Utilities.success);
        this.subscriptions.push(this.buyerInvitationService.getBuyerInformationFromCommunityID(+this.CommunityID).subscribe(x => {
          this.buyerData = x ? x : [];
          this.buyerData.forEach(x => x.MailStatus = x.IsMailInvitationSent ? this.sent : this.yetTobeSent);
        }));
       }));
    });

  }
  calculateMailStatus(rowData) {
    rowData.MailStatus = rowData.IsMailInvitationSent ? 'Sent' : !rowData.IsMailInvitationSent ? 'Yet To be sent' : 'Failed';
    return rowData.MailStatus;
}
}



// WEBPACK FOOTER //
// ./src/app/modules/dashboard/buyer-upload-section/modules/buyer-invitation/buyer-invitation.component.ts